import React from 'react';
import styles from './SelectButton.module.scss';
import cx from 'classnames';
export const SelectBox = ({ value, onClick, checked = false, disabled = false, }) => (<span className={styles.selectButton}>
    <button className={cx(styles.button, {
        [styles.disabled]: disabled,
        [styles.checked]: checked,
    })} onClick={onClick} disabled={disabled}>
      <span className={styles.labelText}>{value}</span>
    </button>
  </span>);
export default SelectBox;
